import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type SendAiChatMessageMutationVariables = Types.Exact<{
  conversationId?: Types.InputMaybe<Types.Scalars['ID']['input']>
  content: Types.Scalars['String']['input']
  viewContext?: Types.InputMaybe<Types.ViewContextInput>
  blobIds?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
  agentId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type SendAiChatMessageMutation = {
  sendAiChatMessage?: {
    conversation: {
      id?: string | null
      title?: string | null
      status: string
      totalInputTokens: number
      totalOutputTokens: number
      createdAt?: string | null
      updatedAt?: string | null
      agent?: { id: string; name?: string | null } | null
      messages: Array<{
        id?: string | null
        role: string
        content?: string | null
        status: string
        toolCalls: any
        usage: any
        viewContext: any
        createdAt?: string | null
        updatedAt?: string | null
      }>
    }
    message: {
      id?: string | null
      role: string
      content?: string | null
      status: string
      toolCalls: any
      usage: any
      viewContext: any
      createdAt?: string | null
      updatedAt?: string | null
      uploads: Array<{ attachmentFilename?: string | null; attachmentUrl?: string | null }>
    }
  } | null
}

export const SendAiChatMessageDocument = gql`
  mutation sendAiChatMessage(
    $conversationId: ID
    $content: String!
    $viewContext: ViewContextInput
    $blobIds: [String!]
    $agentId: ID
  ) {
    sendAiChatMessage(
      conversationId: $conversationId
      content: $content
      viewContext: $viewContext
      blobIds: $blobIds
      agentId: $agentId
    ) {
      conversation {
        id
        title
        status
        agent {
          id
          name
        }
        totalInputTokens
        totalOutputTokens
        createdAt
        updatedAt
        messages {
          id
          role
          content
          status
          toolCalls
          usage
          viewContext
          createdAt
          updatedAt
        }
      }
      message {
        id
        role
        content
        status
        toolCalls
        usage
        viewContext
        createdAt
        updatedAt
        uploads {
          attachmentFilename
          attachmentUrl
        }
      }
    }
  }
`
export type SendAiChatMessageMutationFn = Apollo.MutationFunction<
  SendAiChatMessageMutation,
  SendAiChatMessageMutationVariables
>

/**
 * __useSendAiChatMessageMutation__
 *
 * To run a mutation, you first call `useSendAiChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAiChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAiChatMessageMutation, { data, loading, error }] = useSendAiChatMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      content: // value for 'content'
 *      viewContext: // value for 'viewContext'
 *      blobIds: // value for 'blobIds'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useSendAiChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendAiChatMessageMutation,
    SendAiChatMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendAiChatMessageMutation, SendAiChatMessageMutationVariables>(
    SendAiChatMessageDocument,
    options
  )
}
export type SendAiChatMessageMutationHookResult = ReturnType<typeof useSendAiChatMessageMutation>
export type SendAiChatMessageMutationResult = Apollo.MutationResult<SendAiChatMessageMutation>
export type SendAiChatMessageMutationOptions = Apollo.BaseMutationOptions<
  SendAiChatMessageMutation,
  SendAiChatMessageMutationVariables
>
